import { createIcon } from '@chakra-ui/react'

export const CustomizeIcon = createIcon({
  displayName: 'CustomizeIcon',
  viewBox: '0 0 16 16',
  path: (
    <svg fill="none">
      <path
        d="M0.83252 4.23828L9 4.23828"
        stroke="black"
        strokeWidth="1.64925"
        strokeLinecap="round"
      />
      <path
        d="M14.9863 11.418L6.66058 11.418"
        stroke="black"
        strokeWidth="1.66515"
        strokeLinecap="round"
      />
      <circle
        cx="11.905"
        cy="4.23878"
        r="2.91401"
        stroke="black"
        strokeWidth="1.66515"
      />
      <circle
        cx="3.74658"
        cy="11.7612"
        r="2.91401"
        transform="rotate(-180 3.74658 11.7612)"
        stroke="black"
        strokeWidth="1.66515"
      />
    </svg>
  ),
})
